import { render, staticRenderFns } from "./BankMandateUpsertProvider.vue?vue&type=template&id=071b66ba&scoped=true&"
import script from "./BankMandateUpsertProvider.vue?vue&type=script&lang=ts&"
export * from "./BankMandateUpsertProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b66ba",
  null
  
)

export default component.exports